import { Flex, Skeleton, Typography } from 'antd';
import {
  SymptomCard2Context,
  SymptomCard2ContextProvider
} from 'features/patient/_components/symptom-card/symptom-card-2';
import { usePatientInfoContext } from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { Symptom } from 'lib/documents';
import { getFirstName, pluralize } from 'lib/utils/string/normalise';
import { useContext } from 'react';
import { brainFunctionVisualisations_new } from '../../../../../lib/utils/business/brainfunction-categories';
import { BrainFunctionVisualisationComponent } from './components/brainfunction-visualisation';
import { Legend } from './components/legend';

export interface YourConcussionCardProps {
  isPointSizeIncreasing: boolean;
  getLink: (symptom: Symptom) => string;
}

const TEXT_CONFIG = {
  title: (firstName: string) =>
    `${
      firstName === '' ? "Your test-taker's" : pluralize(firstName)
    } Brain on Concussion`,
  paragraph: (firstName: string) => (
    <>
      {`Understanding ${
        firstName === '' ? "your test-taker's" : pluralize(firstName)
      } brain and its performance on critical functional systems. `}
      <br />
      {`These are the foundation for the recommendations to follow.`}
    </>
  ),
  toggleLabel: (curVal: boolean) => `${curVal ? 'Hide' : 'Show'} all scores`
};

/**
 * Display metrics about a patient over time
 */
export function DisplayBrainfunctionGrid() {
  const { patientInfo } = usePatientInfoContext();

  const firstName = getFirstName(patientInfo.patient.displayName ?? '');
  const { showNumbers } = useContext(SymptomCard2Context);

  if (patientInfo.isLoading) {
    return <Skeleton />;
  }

  return (
    <SymptomCard2ContextProvider
      value={{
        showNumbers
      }}
    >
      <Flex gap={'large'}>
        <div style={{ flex: 2 }}>
          <Typography.Title level={2} className="patient-dashboard__title2">
            {TEXT_CONFIG.title(firstName)}
          </Typography.Title>

          <Typography.Paragraph>
            {TEXT_CONFIG.paragraph(firstName)}
          </Typography.Paragraph>
        </div>
        <div style={{ flex: 1 }}>
          <Legend />
        </div>
      </Flex>

      {/* <ToggleWithLabel
        className={'print-display-none'}
        checked={showNumbers}
        setChecked={setShowNumbers}
        label={TEXT_CONFIG.toggleLabel}
        customStyles={{
          flexStyle: { justifyContent: 'end', paddingTop: '10px' },
          textStyle: { fontSize: 16, fontWeight: 'bold' }
        }}
      /> */}

      {/* Display the first row of metrics */}
      <Flex gap={'large'} justify="center" wrap>
        {brainFunctionVisualisations_new.highLevel.map(vis => (
          <BrainFunctionVisualisationComponent
            key={vis.label}
            visualisation={vis}
            visualisationData={patientInfo}
          />
        ))}
      </Flex>

      {/* Display the remaining metrics */}
      <Flex gap={'large'} justify="center" wrap>
        {brainFunctionVisualisations_new.rest.map(vis => (
          <BrainFunctionVisualisationComponent
            key={vis.label}
            visualisation={vis}
            visualisationData={patientInfo}
          />
        ))}
      </Flex>
    </SymptomCard2ContextProvider>
  );
}
